export default __webpack_public_path__ + "static/media/FAMILY_DASHBOARD_SECTION_IMAGE.b831938d.jpg";